import { LinkButton } from '@/components/Link/LinkButton'
import type React from 'react'
import type { CMSSectionQuickLinks } from '@/types/sanity'
import { Section } from '../Section'

import styles from './SectionQuickLinks.module.scss'
import { ImageCard } from './ImageCard'
import { TextCard } from './TextCard'

type SectionQuickLinks = {
  content: CMSSectionQuickLinks
}
export const SectionQuickLinks: React.FC<SectionQuickLinks> = ({ content }) => {
  const { _id, theme, type, eyebrow, header, mainCta, items } = content

  return (
    <Section id={_id} size="zero" theme={theme} hasWrapper={false}>
      <div className={styles.container}>
        {type === 'imageGrid' && content.underlineTextCta?.text && (
          <LinkButton
            link={content.underlineTextCta}
            className={`${styles.secondCta} type-label`}
          />
        )}
        <div className={styles.contentContainer}>
          {eyebrow && (
            <p className={`${styles.eyebrow} type-label`}>{eyebrow}</p>
          )}
          <p className={`${styles.header} type-h3`}>{header}</p>
          {mainCta?.text && (
            <LinkButton
              link={mainCta}
              className={`${styles.mainCta} type-label`}
            />
          )}
        </div>
        <div className={styles.cardsContainer}>
          <div
            className={
              type === 'imageGrid'
                ? styles.imageCardsContainer
                : styles.textCardsContainer
            }
          >
            {type === 'imageGrid'
              ? items.map((card, index) => (
                  <ImageCard key={index} card={card} />
                ))
              : items.map((card, index) => (
                  <TextCard
                    key={index}
                    card={card}
                    index={content.showNumbering ? index + 1 : null}
                  />
                ))}
          </div>
        </div>
      </div>
    </Section>
  )
}
